import {
  DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_REQUEST,
  DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_REQUEST,
  DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_REQUEST,
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_FAILURE,
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_SUCCESS,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_FAILURE,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_SUCCESS,
  DOCUMENT_PROGRESS__SIGNING_REMIND_FAILURE,
  DOCUMENT_PROGRESS__SIGNING_REMIND_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentProgressAction } from '@app/store/documentProgress/actions';

type DocumentProgressProcessingCountState = number;

const initialState: DocumentProgressProcessingCountState = 0;

export default function reducer(
  state: DocumentProgressProcessingCountState = initialState,
  action: DocumentProgressAction
) {
  switch (action.type) {
    case DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_REQUEST:
    case DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_REQUEST:
    case DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_REQUEST:
      return initialState;
    case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_FAILURE:
    case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_SUCCESS:
    case DOCUMENT_PROGRESS__REQUEST_CANCEL_FAILURE:
    case DOCUMENT_PROGRESS__REQUEST_CANCEL_SUCCESS:
    case DOCUMENT_PROGRESS__SIGNING_REMIND_FAILURE:
    case DOCUMENT_PROGRESS__SIGNING_REMIND_SUCCESS:
      return state + 1;
    default:
      return state;
  }
}
